import { ColumnDef } from '@tanstack/react-table';

import { PaginatedTable } from '@/modules/common/components';

import { useSystemPromptCategories } from '../../api';
import { SystemPromptCategoryResponse } from '../../types';

interface CategoriesTableProps {
  onSelect: (category: SystemPromptCategoryResponse) => void;
}

const columns: ColumnDef<SystemPromptCategoryResponse>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => row.getValue('name'),
  },
];

export function CategoriesTable({ onSelect }: CategoriesTableProps) {
  const { data, isFetching, ...tableProps } = useSystemPromptCategories();

  return (
    <PaginatedTable<SystemPromptCategoryResponse>
      data={data}
      columns={columns}
      onClick={onSelect}
      isLoading={isFetching}
      emptyDescription="No categories found"
      {...tableProps}
    />
  );
}
